var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{attrs:{"data-cy":"update-payment-banner"}},[_vm._v(" A payment is required for your subscription to remain active.  "),_c('an-link',{attrs:{"variant":"primary"},on:{"click":_vm.onUpdatePaymentClick}},[_c('span',[_vm._v("Update payment")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }